import RangeSlider from './RangeSlider';
import StarsRangeSliderComponent from './StarsRangeSlider';
import './RangeSlider.scss';
import './StarsRangeSlider.scss';

export default RangeSlider;
export const StarsRangeSlider = StarsRangeSliderComponent;